import React, {useEffect, useState} from 'react';
import {CircularProgress, TextField} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete'
import {searchAllInventory} from '../../common/api/InventoryApi';
import {formatCurrency} from "../../common/Utils";

const AutoCompleteProductSearch = ({
                                     label = "Search Products",
                                     value,
                                     onChange,
                                     onSelect,
                                     defaultValue,
                                     fieldState,
                                     inventoryList,
                                     keyValue,
                                     hidePrice
                                   }) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);

  const [selectedInventory, setSelectedInventory] = useState(null);
  const [inventoryReady, setInventoryReady] = useState(false);

  useEffect(() => {
    if (inventoryList) {
      setOptions(inventoryList)
      setLoading(false);
      return;
    }
    setLoading(true);
    searchAllInventory({q: inputValue}).then((resp) => {
      setOptions(resp);
      setLoading(false);
      if (defaultValue) {
        setSelectedInventory(resp.find(o => o.id === defaultValue?.id));
      }
      setInventoryReady(true);
    });
  }, []);

  return (
    <>
      <Autocomplete
        open={open}
        required
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={selectedInventory}
        onInputChange={(event, value) => setInputValue(value)}
        onChange={(event, value) => {
          onChange(value);
          setSelectedInventory(value);
          onSelect && onSelect(value);
        }}
        getOptionLabel={(option) => {
          if (hidePrice) {
            return  option.name;
          } else {
            return option.name + ' ' + formatCurrency(option.price);
          }
        }}
        renderOption={(props, option) => {
          let {key, ...rest} = props;
          if (keyValue) {
            key = option[keyValue]
          }
          return (
            <dl key={key} {...rest} style={{
              lineHeight: '0.9em',
              margin: '4px',
              padding: '4px 12px'
            }}>
              <dd className={hidePrice ? 'col col-12' : 'col col-sm-9'}>{option.name}</dd>
              {!hidePrice && <dt className={'col col-sm-3 text-right'}>
                {formatCurrency(option.price)}
              </dt>
              }
            </dl>
          );
        }}
        options={options}
        loading={loading}
        groupBy={(option) => option?.type}
        renderInput={(params) => (
          <TextField
            {...params}
            error={!!fieldState?.error}
            helperText={fieldState?.error?.message}

            label={label}
            variant="outlined"
            InputLabelProps={{shrink: true}}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress size={20}/> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </>
  );
};

export default AutoCompleteProductSearch;
